<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      @if (!loading) {
        <div class="ui-g card mt-4">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="engactivity">
              <div class="sbhd">
                Number of Deal Association Requiring Action
              </div>
              <table>
                <tr>
                  <td class="engtdpanel">
                    Frontline Worker - Deal Association Pending Approval
                    <br /><span>{{
                      activityCount.frontlineDealAsscitionApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Microsoft Viva - Deal Assocation Pending Approval
                    <br /><span>{{
                      activityCount.vivaDealAsscitionApprovalCount
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
